'use strict';

var assign = require(177);

var BpmnModdle = require(16);

var packages = {
  bpmn: require(32),
  bpmndi: require(33),
  dc: require(34),
  di: require(35)
};

module.exports = function(additionalPackages, options) {
  return new BpmnModdle(assign({}, packages, additionalPackages), options);
};